import type {IconType} from 'src/common/Icon'
import atFlag from './assets/at-flag.svg'
import deFlag from './assets/de-flag.svg'
import euFlag from './assets/eu-flag.svg'
import gbFlag from './assets/gb-flag.svg'
import nlFlag from './assets/nl-flag.svg'

type Locale = 'en-us' | 'en-gb' | 'en-nl' | 'en-de' | 'de-de' | 'nl-nl' | 'de-at'

export const langs: Record<Locale, Record<Locale, {icon: IconType; name: string; title: string}>> = {
  'en-us': {
    'en-us': {icon: euFlag, title: 'Language', name: 'EU'},
    'en-gb': {icon: euFlag, title: 'Language', name: 'EU'},
    'en-nl': {icon: euFlag, title: 'Language', name: 'EU'},
    'en-de': {icon: euFlag, title: 'Language', name: 'EU'},
    'de-de': {icon: euFlag, title: 'Language', name: 'EU'},
    'de-at': {icon: euFlag, title: 'Language', name: 'EU'},
    'nl-nl': {icon: euFlag, title: 'Language', name: 'EU'},
  },
  'en-gb': {
    'en-us': {icon: gbFlag, title: 'Language', name: 'United Kingdom'},
    'en-gb': {icon: gbFlag, title: 'Language', name: 'United Kingdom'},
    'en-nl': {icon: gbFlag, title: 'Language', name: 'United Kingdom'},
    'en-de': {icon: gbFlag, title: 'Language', name: 'United Kingdom'},
    'de-de': {icon: gbFlag, title: 'Language', name: 'Vereinigtes Königreich'},
    'de-at': {icon: gbFlag, title: 'Language', name: 'Vereinigtes Königreich'},
    'nl-nl': {icon: gbFlag, title: 'Language', name: 'Verenigd Koninkrijk'},
  },
  'en-nl': {
    'en-us': {icon: nlFlag, title: 'Language', name: 'Netherlands (EN)'},
    'en-gb': {icon: nlFlag, title: 'Language', name: 'Netherlands (EN)'},
    'en-nl': {icon: nlFlag, title: 'Language', name: 'Netherlands (EN)'},
    'en-de': {icon: nlFlag, title: 'Language', name: 'Netherlands (EN)'},
    'de-de': {icon: nlFlag, title: 'Sprache', name: 'Niederlande (EN)'},
    'de-at': {icon: nlFlag, title: 'Sprache', name: 'Niederlande (EN)'},
    'nl-nl': {icon: nlFlag, title: 'Taal', name: 'Nederland (EN)'},
  },
  'en-de': {
    'en-us': {icon: deFlag, title: 'Language', name: 'Germany (EN)'},
    'en-gb': {icon: deFlag, title: 'Language', name: 'Germany (EN)'},
    'en-nl': {icon: deFlag, title: 'Language', name: 'Germany (EN)'},
    'en-de': {icon: deFlag, title: 'Language', name: 'Germany (EN)'},
    'de-de': {icon: deFlag, title: 'Sprache', name: 'Deutschland (EN)'},
    'de-at': {icon: deFlag, title: 'Sprache', name: 'Deutschland (EN)'},
    'nl-nl': {icon: deFlag, title: 'Taal', name: 'Duitsland (EN)'},
  },
  'de-de': {
    'en-us': {icon: deFlag, title: 'Sprache', name: 'Germany'},
    'en-gb': {icon: deFlag, title: 'Sprache', name: 'Germany'},
    'en-nl': {icon: deFlag, title: 'Sprache', name: 'Germany'},
    'en-de': {icon: deFlag, title: 'Sprache', name: 'Germany'},
    'de-de': {icon: deFlag, title: 'Sprache', name: 'Deutschland'},
    'de-at': {icon: deFlag, title: 'Sprache', name: 'Deutschland'},
    'nl-nl': {icon: deFlag, title: 'Sprache', name: 'Duitsland'},
  },
  'nl-nl': {
    'en-us': {icon: nlFlag, title: 'Taal', name: 'Netherlands'},
    'en-gb': {icon: nlFlag, title: 'Taal', name: 'Netherlands'},
    'en-nl': {icon: nlFlag, title: 'Taal', name: 'Netherlands'},
    'en-de': {icon: nlFlag, title: 'Taal', name: 'Netherlands'},
    'de-de': {icon: nlFlag, title: 'Taal', name: 'Niederlande'},
    'de-at': {icon: nlFlag, title: 'Taal', name: 'Nederlande'},
    'nl-nl': {icon: nlFlag, title: 'Taal', name: 'Nederland'},
  },
  'de-at': {
    'en-us': {icon: atFlag, title: 'Sprache', name: 'Austria'},
    'en-gb': {icon: atFlag, title: 'Sprache', name: 'Austria'},
    'en-nl': {icon: atFlag, title: 'Sprache', name: 'Austria'},
    'en-de': {icon: atFlag, title: 'Sprache', name: 'Austria'},
    'de-de': {icon: atFlag, title: 'Sprache', name: 'Österreich'},
    'de-at': {icon: atFlag, title: 'Sprache', name: 'Österreich'},
    'nl-nl': {icon: atFlag, title: 'Sprache', name: 'Oostenrijk'},
  },
}
